/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState } from 'react';
// material
import { Control, ImageUploader } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from './placeholderimages_styles';


/* ========== ~~~~~~~~~~ COMMUNITY TOP ARTICLES : PLACEHOLDER IMAGES ~~~~~~~~~~ ========== */
const PlaceholderImages = props => {
    const { placeholderImageUrl, onChange, onSelectType } = props

    const [selectedType, selectType] = useState(placeholderImageUrl ? 'custom' : 'standard')
    const [customImage, setCustomImage] = useState(placeholderImageUrl ? placeholderImageUrl : '')

    const discardCommunityImage = () => {
      setCustomImage(null)
      onChange(null)
    }

    const handleSelectType = type => {
      selectType(type)
      onSelectType(type)
    }

    const handleUpload = image => {
      setCustomImage(URL.createObjectURL(image))
      onChange(image)
    }

    return (
        <div className={`placeholderimages ${props.classes.placeholderimages} section`}>
            <div className={`sectioncontent`}>
                <Control 
                    text={'Standard'} 
                    value={'standard'} 
                    handleSelect={handleSelectType} 
                    variant={'secondary'} 
                    addCheckWhenSelected={true}
                    selected={selectedType === 'standard'}  
                />
                <Control 
                    text={'Custom'} 
                    value={'custom'}
                    handleSelect={handleSelectType} 
                    variant={'secondary'} 
                    addCheckWhenSelected={true}
                    selected={selectedType === 'custom'}  
                />
                { selectedType === 'custom' &&
                    <ImageUploader 
                      uploadImage={handleUpload}
                      imageSrc={customImage}
                      discardFile={discardCommunityImage} 
                      maxWidth={5000} 
                      maxHeight={5000} 
                      maxSize={5000} 
                      supportedFileTypes={["image/jpeg","image/png","image/gif"]} 
                    />
                }
            </div>
        </div>
    )
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(PlaceholderImages);